import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import { Tooltip } from "@mui/material";
import { Plyr } from "plyr-react";
import "plyr/dist/plyr.css";
import { useState,useEffect } from "react";

import noThumbnail from "../../noThumbnail.png";
import noVideoImage from "../../NTV.png";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import { JPGIconSmall, PdfIconSmall } from "../../../assets/CommonAssets";
import { baseUrlTraining, trainingApiClient } from "../../../http-common";

const AssessmentInfo = ({ label, data, darkMode }) => {
  if (!data) return null;

  const statusStyles = {
    Pass: darkMode
      ? "bg-emerald-900/40 text-emerald-300 border-emerald-600"
      : "bg-emerald-50 text-emerald-700 border-emerald-300",
    Fail: darkMode
      ? "bg-red-900/40 text-red-300 border-red-600"
      : "bg-red-50 text-red-700 border-red-300",
    Pending: darkMode
      ? "bg-amber-900/40 text-amber-300 border-amber-600"
      : "bg-amber-50 text-amber-700 border-amber-300",
  };

  const cardBg = darkMode
    ? "border-slate-600 bg-gradient-to-br from-slate-700 to-slate-800"
    : "border-gray-200 bg-gradient-to-br from-white to-gray-50";

  return (
    <div
      className={`rounded-xl border ${cardBg} px-3 py-1 shadow-sm hover:shadow-md transition`}
    >
      <p
        className={`font-semibold text-sm ${darkMode ? "text-cyan-400" : "text-customBlue"}`}
      >
        {label}
      </p>
      <div className="flex justify-between items-center">
        <span
          className={`text-[15px] ${darkMode ? "text-gray-300" : "text-gray-600"}`}
        >
          Score :
          <span
            className={`ml-1 font-semibold text-[16px] ${darkMode ? "text-white" : "text-gray-900"}`}
          >
            {data?.score === "0/0" ? "-/-" : data?.score}
          </span>
        </span>
        <span
          className={`px-3 py-[2px] rounded-full text-[12px] font-semibold border ${statusStyles[data?.status] ?? ""}`}
        >
          {data.status}
        </span>
      </div>
    </div>
  );
};

const Card = ({
  openBackDrop,
  isPreAssessmentDone,
  darkMode = false,
  setOpenPostModal,
  getAssessmentQuestions,
  course,
  filePreview,
  setFilePreview,
  // renderFilePreview,
  openPostAsstModal,
  setOpenPostAsstModal,
  testData,
  setSelectedRow,
  selectedRow,
  selectedDataForAssessment,
  setSelectedDataForAsessment,
  getTrainingDoc,
}) => {
  const { title, duration, thumbnail } = course;
  const [videoUrl, setVideoUrl] = useState(null);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  // const videoDoc = course?.documents?.find((obj) =>
  //   obj?.fileType?.startsWith("video/"),
  // );
  // const videoUrldata = videoDoc
  //   ? `${baseUrl}/api/trainings/${videoDoc?.path}`
  //   : null;
  const videoList = course?.documents?.filter((obj) =>
    obj?.fileType?.startsWith("video/"),
  );

  // const videoUrls = videoList?.map(
  //   (video) => `${baseUrl}/api/trainings/${video?.path}`,
  // );
  const videoUrls = videoList?.map((video) => `${video?.path}`);
  const videoUrldata = videoUrls?.[0] || null;
  const cardWrap = darkMode
    ? "bg-slate-800 border-slate-700 hover:from-slate-700 hover:to-slate-800"
    : "bg-white border-gray-200 hover:from-cyan-50 hover:to-blue-50";

  const titleC = darkMode ? "text-cyan-400" : "text-customBlue";
  const labelC = darkMode ? "text-gray-200" : "text-gray-800";
  const valueC = darkMode ? "text-gray-400" : "text-gray-600";
  const headingC = darkMode ? "text-white" : "text-gray-700";
  const modalHeaderBg = darkMode
    ? "bg-slate-900 border-white/10"
    : "bg-[#0f172a] border-white/10";

  const statusPending = darkMode
    ? "bg-amber-900/40  text-amber-300  border-amber-600"
    : "bg-amber-50  text-amber-700  border-amber-300";
  const statusCompleted = darkMode
    ? "bg-emerald-900/40 text-emerald-300 border-emerald-600"
    : "bg-emerald-50 text-emerald-700 border-emerald-300";
  const statusInProgress = darkMode
    ? "bg-blue-900/40   text-blue-300   border-blue-600"
    : "bg-blue-50   text-blue-700   border-blue-300";

  const btnClass = darkMode
    ? `w-full  rounded-[6px] border border-cyan-500 text-cyan-400
       transition-all duration-300
       hover:bg-cyan-600 hover:text-white hover:border-cyan-600
       hover:shadow-lg hover:-translate-y-[1px]
       disabled:opacity-40 disabled:cursor-not-allowed`
    : `w-full rounded-[6px] border border-customBlue text-customBlue
       transition-all duration-300
       hover:bg-customBlue hover:text-white
       hover:shadow-lg hover:-translate-y-[1px]
       disabled:opacity-40 disabled:cursor-not-allowed`;

  const tooltipSx = darkMode
    ? {
        bgcolor: "#1e293b",
        color: "#e2e8f0",
        fontSize: "0.75rem",
        fontWeight: 500,
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
        border: "1px solid rgba(100,116,139,0.6)",
        borderRadius: "8px",
        px: 1.5,
        py: 0.75,
      }
    : {
        bgcolor: "#ffffff",
        color: "#1e293b",
        fontSize: "0.75rem",
        fontWeight: 500,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        border: "1px solid rgba(226,232,240,0.8)",
        borderRadius: "8px",
        px: 1.5,
        py: 0.75,
      };
  useEffect(() => {
    return () => {
      if (videoUrl && videoUrl !== "loading") {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, [videoUrl]);
  return (
    <>
      <div
        className={`
          hover:bg-gradient-to-r ${cardWrap}
          border px-4 py-1 rounded-[23px] shadow-md
          transition-all duration-300
          hover:-translate-y-[2px] hover:shadow-xl
        `}
      >
        <h3 className={`text-[18px] font-semibold my-1 ${titleC}`}>
          {course?.training}
        </h3>
        {/* replace */}
        {/* <div className="grid grid-cols-1 md:grid-cols-12 gap-5"> */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-5">
          {/* replace */}
          {/* <div className="md:col-span-2"> */}
          <div className="w-full md:w-[17%]">
            <div
              title={!videoUrldata ? "Video not available" : ""}
              // className="h-[160px] rounded-xl bg-cover bg-center relative cursor-pointer group overflow-hidden shadow-[0_-2px_6px_rgba(0,0,0,0.12),0_8px_16px_rgba(0,0,0,0.16)]"
              className="h-[160px] rounded-xl bg-cover bg-center relative cursor-pointer group overflow-hidden border"
              style={{
                backgroundImage:
                  (videoUrldata && !isPreAssessmentDone) || thumbnail
                    ? `url(${thumbnail ?? noThumbnail})`
                    : `url(${noVideoImage})`,
                cursor: videoUrldata ? "pointer" : "not-allowed",
              }}
              // onClick={() => {
              //   if (videoUrldata && !isPreAssessmentDone)
              //     setVideoUrl(videoUrldata);
              // }}
              // onClick={() => {
              //   if (videoUrls?.length > 0 && !isPreAssessmentDone) {
              //     setSelectedVideoIndex(0);
              //     setVideoUrl(videoUrls[0]);
              //   }
              // }}

              onClick={() => {
                if (videoUrls?.length > 0 && !isPreAssessmentDone) {
                  setSelectedVideoIndex(0);
                  const firstVideo = videoList?.[0];

                  // setVideoUrl("loading"); // ← ye line hai? Modal turant open hoga

                  getTrainingDoc(
                    firstVideo?.fileName,
                    firstVideo,
                    (blobUrl) => {
                      if (!blobUrl) {
                        setVideoUrl(null);
                        return;
                      }
                      setVideoUrl(blobUrl);
                    },
                  );
                }
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent  opacity-70 transition-all duration-300" />

              {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300" /> */}
              {videoUrldata && !isPreAssessmentDone && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-black/50 text-white flex items-center justify-center shadow-xl scale-90 group-hover:scale-100 transition-all duration-300">
                    <Tooltip title="Play">
                      <PlayArrowOutlinedIcon fontSize="large" />
                    </Tooltip>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* replace */}
          {/* <div className="md:col-span-7 flex flex-col justify-between"> */}
          <div className="w-full md:w-[58%] flex flex-col justify-between">
            <div className="space-y-2">
              {/* <p className={`text-[16px] ${valueC}`}>
                <span className={`font-medium ${labelC}`}>Description :</span>{" "}
                <span className="leading-relaxed">{course?.description}</span>
              </p> */}
              <p className={`text-[15px] ${valueC} line-clamp-2`}>
                <span className={`font-semibold ${labelC}`}>Description :</span>{" "}
                <span className="leading-relaxed">{course?.description}</span>
              </p>
              {duration && (
                <p className={`text-[15px] ${valueC}`}>
                  <span className={`font-semibold ${labelC}`}>Duration :</span>{" "}
                  {duration}
                </p>
              )}

              <div className="grid sm:grid-cols-1   xl:grid-cols-3 md:grid-cols-2 gap-3">
                <div
                  className={`flex items-center gap-2 text-[14px] ${valueC}`}
                >
                  <span className={`font-semibold ${labelC} min-w-[86px]`}>
                    Status
                  </span>
                  <span className="text-gray-400"> : </span>
                  {course?.status === "Pending" && (
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 border shadow-sm hover:scale-105 transition-transform ${statusPending}`}
                    >
                      <AccessTimeIcon sx={{ fontSize: 14 }} /> Pending
                    </span>
                  )}
                  {course?.status === "Completed" && (
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 border shadow-sm hover:scale-105 transition-transform ${statusCompleted}`}
                    >
                      <CheckCircleOutlineIcon sx={{ fontSize: 14 }} /> Completed
                    </span>
                  )}
                  {course?.status === "In Progress" && (
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 border shadow-sm hover:scale-105 transition-transform ${statusInProgress}`}
                    >
                      <AccessTimeIcon sx={{ fontSize: 14 }} /> In Progress
                    </span>
                  )}
                </div>

                <div
                  className={`flex items-center gap-2 text-[14px] ${valueC}`}
                >
                  <span className={`font-semibold ${labelC} min-w-[86px]`}>
                    Date
                  </span>
                  <span className="text-gray-400">:</span>
                  <span className="truncate">
                    {course?.["trainingdate"] || "-"}
                  </span>
                </div>

                <div
                  className={`flex items-center gap-2 text-[14px] ${valueC}`}
                >
                  <span className={`font-semibold ${labelC} min-w-[86px]`}>
                    Type
                  </span>
                  <span className="text-gray-400">:</span>
                  <span className="truncate">
                    {course?.["training_type"] || "-"}
                  </span>
                </div>

                {course?.["trainer_name"] && (
                  <div
                    className={`flex items-center gap-2 text-[14px] ${valueC}`}
                  >
                    <span className={`font-semibold ${labelC} min-w-[86px]`}>
                      Trainer
                    </span>
                    <span className="text-gray-400">:</span>
                    <span className="truncate">{course?.["trainer_name"]}</span>
                  </div>
                )}

                {course?.location && (
                  <div
                    className={`flex items-center gap-2 text-[14px] ${valueC}`}
                  >
                    <span className={`font-semibold ${labelC} min-w-[86px]`}>
                      Location
                    </span>
                    <span className="text-gray-400">:</span>
                    <span className="truncate">{course?.location}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="flex gap-1 mt-3">
              {course?.documents
                ?.filter((obj) => obj?.path && obj?.fileType)
                ?.map((obj, i) => (
                  <div key={i}>
                    {obj?.fileType === "application/pdf" && (
                      <Tooltip
                        title={obj?.fileName || " "}
                        arrow
                        placement="top"
                        componentsProps={{
                          tooltip: { sx: tooltipSx },
                          arrow: {
                            sx: {
                              color: darkMode ? "#1e293b" : "#ffffff",
                              "&::before": {
                                border: `1px solid ${darkMode ? "rgba(100,116,139,0.6)" : "rgba(226,232,240,0.8)"}`,
                              },
                            },
                          },
                        }}
                      >
                        <div>
                          <PdfIconSmall
                            // onClick={() => {
                            //   setFilePreview(obj);
                            //   getTrainingDoc(obj?.fileName);
                            // }}
                            onClick={() => {
                              console.log(obj, "obj");
                              getTrainingDoc(obj?.fileName, obj);
                            }}
                          />
                        </div>
                      </Tooltip>
                    )}

                    {obj?.fileType?.startsWith("image/") && (
                      <Tooltip
                        title={obj?.fileName || " "}
                        arrow
                        placement="top"
                        componentsProps={{
                          tooltip: { sx: tooltipSx },
                          arrow: {
                            sx: {
                              color: darkMode ? "#1e293b" : "#ffffff",
                              "&::before": {
                                border: `1px solid ${darkMode ? "rgba(100,116,139,0.6)" : "rgba(226,232,240,0.8)"}`,
                              },
                            },
                          },
                        }}
                      >
                        <div>
                          <JPGIconSmall
                            // onClick={() => {
                            //   setFilePreview(obj);
                            //   getTrainingDoc(obj?.fileName);
                            // }}
                            onClick={() => {
                              getTrainingDoc(obj?.fileName, obj);
                            }}
                          />
                        </div>
                      </Tooltip>
                    )}

                    {/* {obj.fileType ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && (
                    <Tooltip
                      title={obj?.fileName || " "}
                      arrow
                      placement="top"
                      componentsProps={{
                        tooltip: { sx: tooltipSx },
                        arrow: {
                          sx: {
                            color: darkMode ? "#1e293b" : "#ffffff",
                            "&::before": {
                              border: `1px solid ${darkMode ? "rgba(100,116,139,0.6)" : "rgba(226,232,240,0.8)"}`,
                            },
                          },
                        },
                      }}
                    >
                      <span>
                        <WordIconSmall
                         onClick={() => setFilePreview(obj)} />
                      </span>
                    </Tooltip>
                  )} */}
                  </div>
                ))}
            </div>
          </div>
          {/* replace */}
          {/* <div className="md:col-span-3 space-y-3"> */}
          <div className="w-full  md:w-[25%] space-y-3">
            <div className="flex gap-2">
              {" "}
              {course?.pre_assessment_required && (
                <CommonButton
                  disabled={course?.pre_assessment_score?.status === "Pass"}
                  className={btnClass}
                  label={
                    <>
                      <span className="hidden md:inline xl:hidden">
                        Pre-Asst
                      </span>
                      <span className="hidden xl:inline">Pre Assessment</span>
                      <span className="md:hidden">Pre</span>
                    </>
                  }
                  onClick={() => {
                    setSelectedDataForAsessment({
                      ...course,
                      ActiveStatus: "pre",
                    });
                    setOpenPostModal(true);
                  }}
                />
              )}
              {course?.post_assessment_required && (
                <CommonButton
                  disabled={
                    (course?.is_completed === false &&
                      course?.trainingtypeid === 3) ||
                    course?.post_assessment_score?.status === "Pass"
                  }
                  className={btnClass}
                  label={
                    <>
                      <span className="hidden md:inline xl:hidden ">
                        Post-Asst
                      </span>
                      <span className="hidden xl:inline">Post Assessment</span>
                      <span className="md:hidden">Post</span>
                    </>
                  }
                  onClick={() => {
                    setSelectedDataForAsessment({
                      ...course,
                      ActiveStatus: "post",
                    });
                    setOpenPostModal(true);
                  }}
                />
              )}
            </div>

            {course?.pre_assessment_score && (
              <AssessmentInfo
                darkMode={darkMode}
                label="Pre Assessment"
                data={course?.pre_assessment_score}
              />
            )}
            {course?.post_assessment_score && (
              <AssessmentInfo
                darkMode={darkMode}
                label="Post Assessment"
                data={course?.post_assessment_score}
              />
            )}
          </div>
        </div>
      </div>

      {/* {videoUrl && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center">
          <div className="relative w-[95%] md:w-[80%] lg:w-[70%] xl:w-[60%] bg-[#0f172a] rounded-2xl shadow-2xl overflow-hidden animate-[fadeIn_0.3s_ease-out]">
            <div
              className={`flex justify-between items-center px-5 py-4 border-b ${modalHeaderBg}`}
            >
              <h3 className="text-white font-semibold text-lg">{title}</h3>
              <button
                onClick={() => setVideoUrl(null)}
                className="text-gray-300 hover:text-white transition"
              >
                <CloseModalIcon />
              </button>
            </div>
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-[70%] p-3">
                <div key={videoUrl}>
                  <Plyr
                    source={{
                      type: "video",
                      sources: [{ src: videoUrl, type: "video/mp4" }],
                    }}
                    options={{
                      autoplay: true,
                      controls: [
                        "play-large",
                        "play",
                        "current-time",
                        "mute",
                        "volume",
                        "fullscreen",
                      ],
                    }}
                  />
                </div>
              </div>

              {videoUrls?.length > 1 && (
                <div className="w-full md:w-[30%] max-h-[500px] overflow-y-auto border-l border-gray-700">
                  {videoList?.map((video, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedVideoIndex(index);
                        setVideoUrl(videoUrls[index]);
                      }}
                      className={`p-2 cursor-pointer transition ${
                        selectedVideoIndex === index
                          ? darkMode
                            ? "bg-slate-700 text-white"
                            : "bg-gray-200 text-black"
                          : darkMode
                            ? "text-gray-300 hover:bg-slate-700"
                            : "text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      {video?.fileName || `Video ${index + 1}`}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )} */}
      {/* new */}
      {/* {videoUrl && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-md flex items-center justify-center">
          <div
            className="relative w-[95%] md:w-[85%] lg:w-[75%] xl:w-[65%] 
      bg-gradient-to-br from-[#0f172a] to-[#020617] 
      rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] 
      overflow-hidden animate-[fadeIn_0.3s_ease-out] border border-white/10"
          >
            <div
              className={`flex justify-between items-center px-6 py-1 border-b border-white/10 ${modalHeaderBg}`}
            >
              <h3 className="text-white font-semibold text-lg tracking-wide truncate">
                {course?.training}
              </h3>

              <button onClick={() => setVideoUrl(null)} className="p-2">
                <CloseModalIcon />
              </button>
            </div>

            <div className="flex flex-col md:flex-row">
              <div
                className={`w-full ${videoUrls?.length > 1 ? "md:w-[70%]" : "md:w-[100%]"} p-4`}
              >
                <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg">
                  <div key={videoUrl}>
                    <Plyr
                      source={{
                        type: "video",
                        sources: [{ src: videoUrl, type: "video/mp4" }],
                      }}
                      options={{
                        autoplay: true,
                        controls: [
                          "play-large",
                          "play",
                          "current-time",
                          "mute",
                          "volume",
                          "fullscreen",
                        ],
                      }}
                    />
                  </div>
                </div>
              </div>

              {videoUrls?.length > 1 && (
                <div
                  className={`w-full md:w-[30%] max-h-[520px] overflow-y-auto 
            border-l border-white/10 bg-white/5 backdrop-blur-sm`}
                >
                  <div className="p-3 text-xs uppercase text-gray-400 tracking-wider">
                    Playlist
                  </div>

                  {videoList?.map((video, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedVideoIndex(index);
                        setVideoUrl(videoUrls[index]);
                      }}
                      className={`mx-2 mb-2 px-3 py-3 rounded-xl cursor-pointer flex items-center gap-3 transition-all duration-200
                  
                  ${
                    selectedVideoIndex === index
                      ? "bg-gradient-to-r from-indigo-500/30 to-purple-500/30 text-white border border-indigo-400/40 shadow-md"
                      : darkMode
                        ? "text-white"
                        : "hover:text-black hover:bg-gray-50 text-white"
                  }
                `}
                    >
                      <div className="w-7 h-7 flex items-center justify-center text-xs rounded-full bg-white/10">
                        {index + 1}
                      </div>

                      <div className="flex-1 text-sm truncate">
                        {video?.fileName || `Video ${index + 1}`}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )} */}

      {videoUrl && (
        <div className="fixed inset-0 z-[1200] bg-black/70 backdrop-blur-md flex items-center justify-center">
          <div
            className={`relative video-modal
        ${
          videoUrls?.length > 1
            ? "w-[98%] md:w-[92%] lg:w-[88%] xl:w-[85%]"
            : "w-[95%] md:w-[80%] lg:w-[70%] xl:w-[60%]"
        }
        bg-gradient-to-br from-[#0f172a] to-[#020617] 
        rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] 
        overflow-hidden animate-[fadeIn_0.3s_ease-out] 
        border border-white/10 transition-all duration-300`}
          >
            <div
              className={`flex justify-between items-center px-4 py-1 border-b border-white/10 ${modalHeaderBg}`}
            >
              <h3 className="text-white font-semibold text-lg tracking-wide truncate">
                {course?.training}
              </h3>
              <button onClick={() => setVideoUrl(null)} className="p-2">
                <CloseModalIcon />
              </button>
            </div>

            <div className="flex flex-col md:flex-row h-[70vh]">
              <div
                className={`w-full ${
                  videoUrls?.length > 1 ? "md:w-[70%]" : "md:w-full"
                } p-[3px] flex flex-col`}
              >
                <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg flex-1">
                  <div key={videoUrl} className="h-full">
                    <Plyr
                      source={{
                        type: "video",
                        sources: [{ src: videoUrl, type: "video/mp4" }],
                      }}
                      options={{
                        autoplay: true,
                        controls: [
                          "play-large",
                          "play",
                          "current-time",
                          "mute",
                          "volume",
                          "fullscreen",
                          // "progress",
                          "rewind", //
                        ],
                      }}
                    />
                  </div>
                </div>
              </div>

              {videoUrls?.length > 1 && (
                <div className="w-full md:w-[30%] h-full overflow-y-auto border-l border-white/10 bg-white/5 backdrop-blur-sm">
                  <div className="px-3 py-2 text-xs uppercase text-gray-400 tracking-wider">
                    Playlist
                  </div>

                  {videoList?.map((video, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedVideoIndex(index);
                        // setVideoUrl("loading");
                        getTrainingDoc(video?.fileName, video, (blobUrl) => {
                          if (!blobUrl) {
                            setVideoUrl(null);
                            return;
                          }
                          setVideoUrl(blobUrl);
                        });
                      }}
                      className={`mx-2 mb-2 px-3 py-3 rounded-xl cursor-pointer flex items-center gap-3 transition-all duration-200
                  ${
                    selectedVideoIndex === index
                      ? "bg-gradient-to-r from-indigo-500/30 to-purple-500/30 text-white border border-indigo-400/40 shadow-md"
                      : darkMode
                        ? "text-gray-300 hover:bg-white/10"
                        : "text-white hover:bg-white/10"
                  }`}
                    >
                      <div className="w-7 h-7 shrink-0 flex items-center justify-center text-xs rounded-full bg-white/10">
                        {index + 1}
                      </div>

                      <div className="flex-1 text-sm truncate">
                        {video?.fileName || `Video ${index + 1}`}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <style jsx>{`
            .video-modal .plyr {
              height: 100% !important;
            }
            .video-modal .plyr__video-wrapper {
              height: 100% !important;
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default Card;